import {Injectable} from "@angular/core";
import {ConfProxy} from "../../../common/http/services";
import {LogCat, LogManager} from "../../../common/log";
import {SystemConfigurationValues} from "../../../common/configuration/services/system.configuration.utils";
import {IURIParameter} from "../interfaces/iuriparameter";

@Injectable()
export class URLUtilService {
	constructor(private apiHttp: ConfProxy, private sysCfg: SystemConfigurationValues) {
	}

	public isUrlTooLongForGetRequest(controllerName: string, functionName: string, p: IURIParameter[]) {
		const url = this.apiHttp.getIframeUrl(controllerName, functionName, p);
		const result = this.isUrlTooLongForGetRequestByString(url);
		return result;
	}

	public isUrlTooLongForGetRequestByString(url: string) {
		if (url.length >= this.apiHttp.maxUrlLength) {
			LogManager.debug(LogCat.ManagementReports.General, "request too long for HTTP", url);
			return true;
		} else {
			return false;
		}
	}

}
